export const formatCurrency = (nominal) => {
  let rupiahInd = Intl.NumberFormat("id-ID", {
    style: "currency",
    currency: "IDR",
  });

  return rupiahInd.format(nominal);
};
